import ConnectAdmin from "src/components/ConnectAdmin/ConnectAdmin";

export default {
    connectAdminComponent: null,

    dispose() {
        if (this.connectAdminComponent) {
            this.connectAdminComponent.dispose();
        }
        this.connectAdminComponent = null;
    },

    show() {
        if (!this.connectAdminComponent) {
            this.connectAdminComponent = new ConnectAdmin({
                source: '<x-connect-admin></x-connect-admin>'
            });
            this.connectAdminComponent.attach(document.body);
        }
        this.connectAdminComponent.show()
    }
};